import config from '../../config';

import { invokeApig } from '../../utils/awsLib';

import * as endpoints from '../../endpoints';

import { authenticateCurrentUser } from '../authenticate/actions';

import { flashMessage } from '../flash/actions';

import * as types from './types';
import * as profileStatus from './status';

function getProfileRequest() {
  return {
    type: types.PROFILE_REQUEST,
  };
}

function getProfileSuccess(status, profiles) {
  return {
    type: types.PROFILE_SUCCESS,
    payload: {
      status,
      profiles,
    },
  };
}

function getProfileFail(status, message) {
  return {
    type: types.PROFILE_FAILURE,
    payload: {
      status,
      statusText: message,
    },
  };
}

export function getProfile(body) {
  return async (dispatch) => {
    dispatch(getProfileRequest());
    const path = endpoints.PROFILE;
    let result;
    try {
      const token = await dispatch(authenticateCurrentUser());
      result = await invokeApig({
        path,
        method: 'POST',
        body,
        gateway: config.apiGateway,
      }, token);
    } catch (e) {
      console.log('getProfile', e.message);
      const errStatus = profileStatus.PROFILE_STATUS_ERROR;
      dispatch(getProfileFail(errStatus, e.message));
      dispatch(flashMessage(`Fail to get profile because ${e.message}`, 'error'));
      return errStatus;
    }
    
    dispatch(getProfileSuccess(profileStatus.PROFILE_STATUS_OK, result));
    return profileStatus.PROFILE_STATUS_OK;
  };
}



// WEBPACK FOOTER //
// ./src/redux/profile/actions.js